(() => {
  const key = '__montcartaBlackFriday2026';
  if (window[key]) { window[key].init(document); return; }
  const controllers = new WeakMap();
  function setup(root) {
    if (controllers.has(root)) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const cleanups = [];
    controllers.set(root, () => { controller.abort(); cleanups.forEach(fn => fn()); controllers.delete(root); });
    const countdown = root.querySelector('[data-end], [data-cycle-start]');
    const end = Date.parse(countdown?.dataset.end || '');
    const anchor = Date.parse(countdown?.dataset.cycleStart || '');
    const recurring = Number.isFinite(anchor);
    const period = 48 * 60 * 60 * 1000;
    if (recurring || Number.isFinite(end)) {
      let timer;
      const tick = () => {
        const now = Date.now();
        const deadline = recurring ? anchor + (Math.floor((now - anchor) / period) + 1) * period : end;
        const difference = Math.max(0, deadline - now);
        const values = {days: Math.floor(difference / 86400000), hours: Math.floor(difference / 3600000) % 24, minutes: Math.floor(difference / 60000) % 60, seconds: Math.floor(difference / 1000) % 60};
        for (const [name, value] of Object.entries(values)) countdown.querySelector(`[data-time="${name}"]`).textContent = String(value).padStart(2, '0');
        const expired = difference === 0;
        countdown.querySelector('.mcbf-clock').hidden = expired;
        countdown.querySelector('.mcbf-ended').hidden = !expired;
        if (expired) clearInterval(timer);
      };
      tick();
      if (recurring || end > Date.now()) timer = setInterval(() => { if (!document.hidden) tick(); }, 1000);
      document.addEventListener('visibilitychange', tick, {signal});
      cleanups.push(() => clearInterval(timer));
    }
    const motion = root.querySelector('.mcbf-marquee-toggle');
    motion?.addEventListener('click', () => {
      const paused = motion.closest('.mcbf-marquee').classList.toggle('is-paused');
      motion.setAttribute('aria-pressed', String(paused));
      motion.setAttribute('aria-label', paused ? motion.dataset.playLabel : motion.dataset.pauseLabel);
      motion.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
    }, {signal});
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    root.querySelectorAll('[data-slider]').forEach(slider => {
      const rail = slider.querySelector('[data-rail]');
      const items = [...rail.children];
      const dots = slider.querySelector('[data-dots]');
      const next = slider.querySelector('[data-next]');
      const previous = slider.querySelector('[data-prev]');
      let current = 0;
      const buttons = items.map((item, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', `${index + 1} / ${items.length}`);
        button.addEventListener('click', () => go(index), {signal});
        dots.append(button);
        return button;
      });
      const update = () => {
        const left = rail.getBoundingClientRect().left;
        let nearest = 0;
        let distance = Infinity;
        items.forEach((item, index) => {
          const delta = Math.abs(item.getBoundingClientRect().left - left);
          if (delta < distance) { nearest = index; distance = delta; }
        });
        current = nearest;
        buttons.forEach((button, index) => button.setAttribute('aria-current', String(index === current)));
      };
      const go = index => {
        const chosen = (index + items.length) % items.length;
        rail.scrollTo({left: rail.scrollLeft + items[chosen].getBoundingClientRect().left - rail.getBoundingClientRect().left, behavior: reduced.matches ? 'auto' : 'smooth'});
      };
      next.addEventListener('click', () => go(current + 1), {signal});
      previous.addEventListener('click', () => go(current - 1), {signal});
      rail.addEventListener('scroll', update, {passive:true, signal});
      const observer = new ResizeObserver(update);
      observer.observe(rail);
      cleanups.push(() => observer.disconnect());
      update();
    });
    root.querySelectorAll('video').forEach(video => {
      video.addEventListener('play', () => root.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); }), {signal});
    });
  }
  function init(context) { context.querySelectorAll('[data-mcbf]').forEach(setup); }
  window[key] = {init};
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-mcbf]').forEach(root => controllers.get(root)?.()));
})();
